import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import guides from "./serviceGuides.json";
import "./Contant.css";

// Each service page has a distinct, practical guide rather than repeating
// international-recruitment marketing copy across unrelated services.
function Contant({ PageName }) {
  const guide = guides[PageName];
  useEffect(() => { window.scrollTo(0, 0); }, []);
  if (!guide) return <main className="HDSD8715"><h1>{PageName}</h1><p>See our complete <Link to="/Services">service directory</Link>.</p></main>;
  return <main>
    <div className="Hd01864"><h1 className="Jsf07255">{guide.title}</h1></div>
    <div className="HDSD8715"><p className="FD097531">{guide.lead}</p>
      {guide.sections.map((section) => <section key={section.heading} style={{margin:'30px 0'}}>
        <h2 style={{fontSize:'clamp(21px, 2.3vw, 30px)',marginBottom:12}}>{section.heading}</h2>
        <p className="FD097531">{section.paragraph}</p>
        <ul style={{lineHeight:1.85,margin:'14px 0',paddingLeft:'25px'}}>{section.items.map(item=><li key={item}>{item}</li>)}</ul>
      </section>)}
      <p className="FD097531">For a hiring discussion tailored to your organisation, <Link to="/ContactUs">contact Quarec Resources</Link>. These explanations are educational, not a guarantee of placement or a substitute for legal advice.</p>
      <p className="FD097531">Useful tools: <Link to="/Resources/Hiring-Brief">Hiring brief builder</Link> · <Link to="/Resources/Interview-Scorecard">Interview scorecard</Link>.</p>
    </div>
  </main>;
}
export default Contant;
